var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 56,
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2 16.7 C21.2 16.7 15.4 22.4 15.4 29.5 C15.4 36.6 21.1 42.3 28.2 42.3 C35.3 42.3 41 36.5 41 29.5 C41 22.5 35.2 16.7 28.2 16.7 Z M28.2 37.7 C23.7 37.7 20 34 20 29.5 C20 25 23.7 21.3 28.2 21.3 C32.7 21.3 36.4 25 36.4 29.5 C36.4 34 32.7 37.7 28.2 37.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6 16.4 C38.6 14.8 39.9 13.5 41.5 13.5 C43.1 13.5 44.4 14.8 44.4 16.4 C44.4 18 43.1 19.3 41.5 19.3 C39.9 19.3 38.6 18 38.6 16.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 8.9 C46.4 6.2 42.7 4.8 38.5 4.8 L17.9 4.8 C9.2 4.8 3.4 10.6 3.4 19.3 L3.4 39.8 C3.4 44.1 4.8 47.8 7.6 50.5 C10.3 53.1 13.9 54.4 18 54.4 L38.4 54.4 C42.7 54.4 46.3 53 48.9 50.5 C51.6 47.9 53 44.2 53 39.9 L53 19.3 C53 15.1 51.6 11.5 49 8.9 Z M48.6 39.9 C48.6 43 47.5 45.5 45.7 47.2 C43.9 48.9 41.4 49.8 38.4 49.8 L18 49.8 C15 49.8 12.5 48.9 10.7 47.2 C8.9 45.4 8 42.9 8 39.8 L8 19.3 C8 16.3 8.9 13.8 10.7 12 C12.4 10.3 15 9.4 18 9.4 L38.6 9.4 C41.6 9.4 44.1 10.3 45.9 12.1 C47.6 13.9 48.6 16.4 48.6 19.3 L48.6 39.9 L48.6 39.9 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/InstagramIcon.f0128f279b83db29b6728b648258da40.svg";
export { ForwardRef as ReactComponent };